import { ICodReview } from './cod-review.interface';
import { ReviewNextStep, ReviewResult, ReviewType } from '../../../../enums';

export interface IManagerReview extends ICodReview {
    type: ReviewType;
    reviewResult: ReviewResult;
    nextStep?: ReviewNextStep;
}
